// extracted by mini-css-extract-plugin
export default {"container":"commentBlock_container__f6WWP","header":"commentBlock_header__j4vMu","comment":"commentBlock_comment__d5q6l"};